// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGFile = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.466 0c.076 0 .153.008.233.023.1.02.196.059.288.104.023.011.046.023.068.037.09.052.177.111.252.187l6.345 6.4c.075.076.135.163.186.255.013.023.025.045.036.068.045.093.083.19.103.295.015.075.023.153.023.231v13.2c0 1.884-1.468 3.2-3.569 3.2H6.534c-2.1 0-3.568-1.316-3.568-3.2V3.6c0-1.985 1.6-3.6 3.568-3.6zm-1.133 2H6.25C5.56 2 5 2.56 5 3.25v17.917c0 .689.68.833 1.25.833h12.5c.57 0 1.25-.144 1.25-.833v-12.5h-4.583c-1.149 0-2.084-.935-2.084-2.084V2z",
      id: "file__a"
    })
  }), /*#__PURE__*/_jsx("use", {
    xlinkHref: "#file__a"
  })]
}));
SVGFile.displayName = 'SVGFile';
export default SVGFile;